import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Actions, ActionTypes } from '../actions/customer-storage.actions';
import { Customer } from '@appRoot/core/customer/models';


export function selectId(entity: Customer): number {
    return entity.id;
}

export const adapter: EntityAdapter<Customer> = createEntityAdapter<Customer>({
    selectId: selectId,
    sortComparer: false,
});

export interface State extends EntityState<Customer> {}

export const initialState: State = adapter.getInitialState();

export function reducer(state = initialState, action: Actions): State {
    switch (action.type) {

        case ActionTypes.RESET:
            return {
                ...initialState
            };

        case ActionTypes.ADD_ONE:
            return adapter.addOne(action.payload, state);

        case ActionTypes.UPSERT_ONE:
            return adapter.upsertOne(action.payload, state);

        case ActionTypes.UPSERT_MANY:
            return adapter.upsertMany(action.payload, state);

        case ActionTypes.UPDATE_ONE:
            return adapter.updateOne({
                id: selectId(action.payload),
                changes: action.payload,
            }, state);

        case ActionTypes.REMOVE_ONE:
            return adapter.removeOne(selectId(action.payload), state);

        case ActionTypes.REMOVE_MANY:
            return adapter.removeMany(action.payload.map(e => selectId(e)), state);

        case ActionTypes.UPDATE_EMAIL_LOGS:
            return adapter.updateOne({
                id: action.payload.id,
                changes: { emailLogs: action.payload.email_logs },
            }, state);

        case ActionTypes.UPDATE_SUBSCRIPTION:
            return adapter.updateOne({
                id: action.payload.id,
                changes: { subscription: action.payload.subscription },
            }, state);

        case ActionTypes.UPDATE_TIME_TRACKING:
            return adapter.updateOne({
                id: action.payload.id,
                changes: { timeTracking: action.payload.time },
            }, state);

        case ActionTypes.UPDATE_INVOICE:
            return adapter.updateOne({
                id: action.payload.id,
                changes: { invoice: action.payload.invoice },
            }, state);

        case ActionTypes.UPDATE_BILLING:
            return adapter.updateOne({
                id: action.payload.id,
                changes: {
                    paymentMode: action.payload.paymentMode,
                    creditCard: action.payload.creditCard,
                    creditName: action.payload.creditName,
                    creditExpDate: action.payload.creditExpDate
                },
            }, state);

        case ActionTypes.UPDATE_PAYMENT_MODE:
            return adapter.updateOne({
                id: action.payload.id,
                changes: { paymentMode: action.payload.paymentMode },
            }, state);

        case ActionTypes.UPDATE_CREDIT_CARD:
            return adapter.updateOne({
                id: action.payload.id,
                changes: {
                    creditCard: action.payload.creditCard,
                    creditName: action.payload.creditName,
                    creditExpDate: action.payload.creditExpDate
                },
            }, state);

        case ActionTypes.UPDATE_EMAIL:
            return adapter.updateOne({
                id: action.payload.id,
                changes: { email: action.payload.email },
            }, state);

        default:
            return state;
    }
}
